import { render, staticRenderFns } from "./DsTree.vue?vue&type=template&id=72216b46&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./DsTree.vue?vue&type=script&lang=js&"
export * from "./DsTree.vue?vue&type=script&lang=js&"
import style0 from "./DsTree.vue?vue&type=style&index=0&id=72216b46&prod&lang=scss&scoped=true&"
import style1 from "./DsTree.vue?vue&type=style&index=1&id=72216b46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72216b46",
  null
  
)

export default component.exports